import React, { useState } from "react";
import Select from "react-select";
import countryData from "world-countries/countries.json"; 

const CountryCode = ({ handleChange: externalHandleChange }) => {
  // Map countryData to create options
  const countryOptions = countryData.map((country) => {
    const flagUrl = `https://flagcdn.com/w320/${country.cca2.toLowerCase()}.png`;
  
    return {
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
         
          <img
            src={flagUrl}
            alt={country.name.common}
            style={{ width: 18, height: 15, marginRight: 10 }}
          />
          {country.name.common} {/* Add short form here */}
        </div>
      ),
      value: country.cca2, // ISO Alpha-2 code
      name: country.name.common, // Full name of the country
      shortForm: country.cca3, // ISO Alpha-3 code for the short form
      phoneCode: `${country.idd.root || ""}${country.idd.suffixes ? country.idd.suffixes[0] : ""}`,
    };
  });
  
  // Set India as the default selected country
  const defaultCountry = countryOptions.find((country) => country.name === "India") || null;
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);

  const handleChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    // console.log("Selected Country:", selectedOption);

    // Call the external handleChange function if provided
    if (externalHandleChange) {
      externalHandleChange(selectedOption?.phoneCode || "");
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #5A4FCF", 
      backgroundColor: "#342f4f", 
      color: "#fff",
      borderRadius: "4px",
      minHeight: "61px",
      padding: "4px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#7C66D5",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#fff", 
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#2D1D44", 
      color: "#fff",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#3E295A" : "#2D1D44", 
      color: "#fff",
      "&:hover": {
        backgroundColor: "#3E295A", 
      },
    }),
    indicatorSeparator: () => ({
      display: "none", 
    }),
    dropdownIndicator: () => ({
      display: "none", 
    }),
  };

  return (
    <div style={{ width: "100%", height: "100%", color: "#fff" }}>
     <Select
  options={countryOptions}
  onChange={handleChange}
  value={{
    ...selectedCountry,
    label: (
      <div style={{ display: "flex", alignItems: "center" ,justifyContent:"center"}}>
        <img
          src={`https://flagcdn.com/w320/${selectedCountry?.value?.toLowerCase()}.png`}
          alt={selectedCountry?.name}
          style={{ width: 20, height: 15, marginRight: 10 }}
        />
        {selectedCountry?.phoneCode || ""}
      </div>
    ), // Display flag and phone code
  }}
  styles={customStyles}
/>

    </div>
  );
};

export default CountryCode;
